import React from 'react';
import { heroQuotes } from '../data/salesCopy';
export function SocialProofStrip() {
  return <section aria-label="Educator quotes" className="w-full border-b border-line bg-surface" data-id="element-207" data-mp="3fdu9xycezzah">
      <div className="mx-auto grid max-w-6xl grid-cols-1 divide-y divide-line px-4 py-8 sm:px-5 sm:py-12 md:grid-cols-3 md:gap-10 md:divide-y-0" data-id="element-208" data-mp="30oy4m91qt0dk">
        {heroQuotes.map(quote => <figure key={quote.name} className="flex h-full flex-col py-5 first:pt-0 md:py-0" data-id="element-209" data-mp="2rnqb04a68npt">
            <blockquote className="text-[15px] leading-relaxed text-ink-soft" data-id="element-210" data-mp="2wmtfnnm8orx9">
              “{quote.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-4 text-[11px] font-semibold uppercase tracking-[0.1em] text-ink-muted sm:pt-5 sm:text-xs" data-id="element-211" data-mp="2hqc00k70or4w">
              {quote.name} · {quote.role}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}